import { z } from "zod";
import { paginated, paginationQuery } from "./common.js";
/**
 * `ir_publisher` (Publicador, 28 sep 2026) queda entre analista y
 * administrador: sube y administra insights, sin las demás herramientas de
 * administración.
 */
export const platformRole = z.enum(["ir_admin", "ir_publisher", "ir_analyst", "client"]);
/** Roles asignables en v1. `client` se modela pero no se puede asignar todavía. */
export const assignableRole = z.enum(["ir_admin", "ir_publisher", "ir_analyst"]);
export const inviteUserInput = z.object({
    email: z.email(),
    name: z.string().trim().min(1).max(120),
    role: assignableRole,
    /** Vacío significa "la organización interna"; lo resuelve el handler. */
    organizationIds: z.array(z.string().min(1)).max(20).default([]),
});
/**
 * Al menos una organización, siempre.
 *
 * Dejar a alguien con cero no produce un error: produce un usuario que abre
 * el catálogo, no ve nada, y no tiene forma de saber por qué. Para retirar el
 * acceso ya existe `banned`, que sí lo dice. Decisión de producto, tomada el
 * 5 de septiembre de 2026.
 *
 * `inviteUserInput.organizationIds` sí admite la lista vacía, pero ahí
 * significa otra cosa —«usa la interna»— y el handler la resuelve antes de
 * escribir nada.
 */
export const setUserOrganizationsInput = z.object({
    organizationIds: z
        .array(z.string().min(1))
        .min(1, "Un usuario debe pertenecer al menos a una organización")
        .max(20),
});
/**
 * Nombre y correo siempre juntos, no un parche parcial: el diálogo que lo usa
 * (`EditUserDialog`) edita ambos a la vez, igual que `setUserOrganizationsInput`
 * reemplaza la lista completa en vez de aceptar altas/bajas sueltas.
 */
export const updateUserProfileInput = z.object({
    name: z.string().trim().min(1).max(120),
    email: z.email(),
});
export const userSummary = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string(),
    role: platformRole,
    banned: z.boolean(),
    lastSeenAt: z.string().nullable(),
    grantedStudies: z.number().int(),
    /**
     * Las organizaciones a las que pertenece. La pantalla de usuarios las
     * enseña en su propia columna: con el acceso resuelto por organización
     * (diseño §3.2), «a qué organizaciones pertenece» es lo que decide qué
     * insights ve, así que no verlo obliga a adivinarlo.
     */
    organizations: z.array(z.object({ id: z.string(), name: z.string() })),
    createdAt: z.string(),
});
export const userList = paginated(userSummary);
export const userListQuery = paginationQuery.extend({
    q: z.string().trim().max(200).optional(),
    role: platformRole.optional(),
});
//# sourceMappingURL=user.js.map